import axios from '@/service-library/api-axios'
import { AuthCredential } from '@/types/credentials'

export function getCredential(path: string, credentialId: string) {
  return axios.get<AuthCredential>(
    `${path}/${credentialId}?redirect_uri=${window.location.origin}/credential-authenticated`,
  )
}
